{
  "permissions": {
    "noPermission": "Vous n'êtes pas autorisé à effectuer cette action",
    "viewOnly": "Afficher uniquement"
  },
  "importFinished": "L'importation est terminée",
  "switchLevel": "Niveau du commutateur",
  "removeFilter": "Supprimer le filtre",
  "styleByProperty": "Définissez les dimensions du modèle à l'aide des valeurs des propriétés des éléments de liste",
  "styleByPropertyTooltip": "Lorsque cette option est activée, la taille des modèles de cette couche est déterminée à l'aide des dimensions de votre tableau des éléments de liste. Les éléments de votre liste doivent contenir des colonnes numériques supplémentaires pour « Largeur », « Longueur » et « Hauteur » pour utiliser cette option. Pour obtenir des instructions détaillées, consultez notre",
  "styleByPropertyTooltipLink": "article de la base de connaissances",
  "copy": {
    "copyTo": "Copier vers cet emplacement",
    "setTo": "Définir un nouvel emplacement",
    "tooltip": {
      "Map": "Impossible de copier dans un plan",
      "Layer": "Impossible de copier dans une couche"
    }
  },
  "digitalTwin": {
    "cameraModes": {
      "orbit": "Caméra Orbit",
      "walk": "Promenez-vous",
      "fly": "Caméra Fly"
    }
  },
  "venue_bookmark": "Marque-page du lieu",
  "venue_bookmark_form": {
    "save": "Enregistrer le signet",
    "name": "Nom"
  },
  "venue_bookmark_view": {
    "bookmarks": "Signets",
    "delete_bookmark": "Supprimer le signet",
    "create_bookmark": "Créer un signet à partir de la vue actuelle",
    "no_bookmarks": "Pas de signets"
  },
  "venue_bookmark_no_venue_error": {
    "title": "Impossible de créer un signet",
    "message": "Vous ne pouvez pas créer de signet en dehors d'un lieu"
  },
  "venue_bookmark_creation_error": {
    "title": "Impossible de créer un signet",
    "message": "Une erreur s'est produite lors de la création du signet. Veuillez réessayer ultérieurement."
  },
  "controls": {
    "toggle_street_names": "Noms de rues et de lieux",
    "disabled_terrain_sitemap_3d": "Le terrain ne peut pas être activé lorsqu'un plan du site 3D est affiché",
    "disabled_3d_buildings_sitemap_3d": "Les bâtiments 3D ne peuvent pas être activés lorsqu'un plan du site 3D est affiché"
  },
  "modelPreview": {
    "front_view": "Vue de face",
    "front_left_view": "Vue avant gauche",
    "capture_thumbnail": "Capture d'une miniature",
    "preview_info_heading": "Vérifiez l'aperçu et ajustez le modèle si nécessaire en vous assurant que :",
    "preview_info_model_appears": "Le modèle apparaît dans l'aperçu comme prévu",
    "preview_info_centered": "Le centre du modèle croise la ligne bleue",
    "preview_info_orientation": "Le modèle est correctement orienté et fait face vers l'avant lorsqu'il est vu de face.",
    "model_not_supported_error": "Le modèle n'est pas pris en charge, essayez un autre fichier ou contactez le support."
  },
  "modelShowThumbnailUploader": "ou téléchargez un fichier",
  "not_support_custom_colour": "Le modèle que vous avez chargé ne prend pas en charge les couleurs personnalisées. Pour savoir comment l'activer, consultez l'article ",
  "areaModel": {
    "distribution": {
      "title": "Distribution",
      "random": "Aléatoire",
      "uniform": "Uniforme"
    },
    "rotation": {
      "title": "Rotation",
      "random": "Aléatoire",
      "uniform": "Uniforme"
    }
  },
  "systemDataFieldNames": {
    "MapObjectName": "Nom de l'objet cartographique",
    "MapObjectArea": "Région",
    "MapObjectLength": "Longueur",
    "Coordinates": "Coordonnées",
    "RouteTime": "Durée de l'itinéraire",
    "QuantityOfModelsOnLine": "Quantité",
    "QuantityOfModelsInArea": "Quantité",
    "RotationZOfModelsInArea": "Rotation",
    "IconRotation": "Rotation",
    "ModelAltitude": "Altitude"
  },
  "dateTimeFilter": {
    "newObjectFilteredTitle": "Objet cartographique filtré",
    "newObjectFilteredBody": "L'objet cartographique nouvellement créé a été filtré par le filtre de date et d'heure"
  },
  "sitemapVersion": {
    "twoDimensional": "2E",
    "threeDimensional": "3D"
  },
  "shareMap": {
    "copyNotification": "Le lien de la carte partagée a été copié dans votre presse-papiers",
    "useDescription": "Les liens partagés sont conçus pour un usage privé avec des personnes spécifiques uniquement.",
    "warning": "La publication publique ou la distribution de masse (par exemple, sur des sites Web, les réseaux sociaux ou des listes de diffusion) n'est pas autorisée. Pour en savoir plus sur la façon de partager des plans publiquement, veuillez contacter support@iventis.com.",
    "customSharedLinkDuration": {
      "description": "Définissez la durée du lien :",
      "duration": {
        "ThreeDays": "3 jours",
        "SevenDays": "7 jours",
        "FourteenDays": "14 jours",
        "ThirtyDays": "30 jours"
      },
      "contactSupport": "Si vous devez fournir un accès pendant plus de 30 jours, veuillez contacter support@iventis.com pour discuter de vos besoins."
    }
  },
  "screenshot": {
    "take_screenshot": "Prendre une capture d'écran",
    "screenshot": "capture d'écran",
    "copiedToClipboardToast": {
      "title": "Capture d'écran copiée dans le presse-papiers",
      "message": "Vous pouvez maintenant le coller dans une autre application"
    },
    "downloadedImageToast": {
      "title": "Capture d'écran téléchargée",
      "message": "Vous pouvez le trouver dans votre dossier de téléchargements"
    },
    "errorToast": {
      "title": "Quelque chose s'est mal passé",
      "message": "Impossible de prendre la capture d'écran, veuillez réessayer"
    }
  },
  "style": {
    "altitude": "Altitude"
  }
}